// D-CRX-33 R3 — the STATUS DICTIONARY (Andrew's preview: "one vocabulary, every screen… A color means
// the same thing on every screen"). Semantics adopted platform-wide as a rule going forward, applied
// opportunistically as screens are touched (Q-STYLE working position). Existing tokens, not the v2
// palette — that lands when Patrick + Andrew close Q-STYLE.
//   green: Approved · Paid · Signed · Current        amber: Pending · Viewed · Expiring · Aging
//   red:   Denied · Rejected · Positive · Overdue · Expired
//   blue:  In workflow · Claimed · Ready             grey:  N/A · Not started
export type StatusTone = 'green' | 'amber' | 'red' | 'blue' | 'grey'

const TONES: Record<StatusTone, string> = {
  green: 'var(--color-success, #15803d)',
  amber: '#a16207',
  red: 'var(--color-danger, #b3261e)',
  blue: 'var(--color-accent, #0f6e64)',
  grey: 'var(--color-text-mute)',
}

const MAP: Record<string, StatusTone> = {
  approved: 'green', paid: 'green', signed: 'green', current: 'green', completed: 'green',
  active: 'green', cleared: 'green', delivered: 'green', negative: 'green',
  pending: 'amber', viewed: 'amber', expiring: 'amber', aging: 'amber', sent: 'amber',
  submitted: 'amber', pending_approval: 'amber', borderline: 'amber', awaiting: 'amber',
  denied: 'red', rejected: 'red', positive: 'red', overdue: 'red', expired: 'red',
  escalated: 'red', voided: 'red', cancelled: 'red', deceased: 'red',
  in_workflow: 'blue', claimed: 'blue', ready: 'blue', scheduled: 'blue', open: 'blue',
  shipped: 'blue', draft: 'blue',
  na: 'grey', not_started: 'grey', none: 'grey',
}

export function statusTone(status: string | null | undefined): StatusTone {
  if (!status) return 'grey'
  return MAP[String(status).toLowerCase().replace(/[\s-]+/g, '_')] ?? 'grey'
}

export function statusColor(status: string | null | undefined): string {
  return TONES[statusTone(status)]
}
